export default "__VITE_ASSET__DNAmYzll__"